module.exports = __webpack_public_path__ + "teqbahn-assets/media/TeqbahnLabs9.79ff00df.png";